<template>
  <LoadingBar ref="loadingBar" />
  <div class="w-full fixed top-0 border-b border-gray-200 dark:border-gray-700 z-10 bg-white dark:bg-black">
    <nav class="container mx-auto flex justify-between max-sm:px-2">
      <div
        class="max-w-screen-xl flex flex-wrap items-center justify-start max-xs:justify-center mx-auto sm:mx-0 py-4 gap-5">
        <router-link to="/fa" class="flex items-center space-x-3 rtl:space-x-reverse hover:opacity-75">
          <img src="@/assets/images/logo.png" class="w-10" alt="" />
          <img src="@/assets/images/text-logo.png" class="object-contain w-56" alt="" />
        </router-link>
        <nav class="hidden xl:flex gap-4">
          <router-link to="/fa"
            class="flex items-center justify-center hover:text-primary dark:hover:text-primary xl:justify-start refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa', 'text-gray-800 dark:text-white': $route.path !== '/fa' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
                fill="currentColor" />
            </svg>
            <span class="mr-2 text-md">صفحه اصلی</span>
          </router-link>
          <router-link to="/fa/library"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/library', 'text-gray-800 dark:text-white': $route.path !== '/fa/library' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
                fill="currentColor" />
            </svg>
            <span class="mr-2 text-md">کتابخانه</span>
          </router-link>
          <router-link to="/fa/posts"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/posts', 'text-gray-800 dark:text-white': $route.path !== '/fa/posts' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
                fill="currentcolor" />
            </svg>
            <span class="mr-2 text-md">مقالات</span>
          </router-link>
          <router-link to="/fa/media"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/media', 'text-gray-800 dark:text-white': $route.path !== '/fa/media' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                fill="currentColor" />
            </svg>
            <span class="mr-2 text-md">آرشیو ویدیویی</span>
          </router-link>
          <router-link to="/fa/aboutus"
            class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
            :class="{ 'text-primary': $route.path === '/fa/aboutus', 'text-gray-800 dark:text-white': $route.path !== '/fa/aboutus' }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
              <path
                d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
                fill="currentcolor" />
            </svg>
            <span class="mr-2 text-md">درباره ما</span>
          </router-link>
        </nav>
      </div>
      <div class="grid  grid-cols-1 xl:grid-cols-2 gap-2 items-center relative text-gray-800 dark:text-white">
        <span class="hidden xl:block mr-2 text-md">حالت شب</span>
        <label class="inline-flex items-center cursor-pointer">
          <input type="checkbox" value="" class="sr-only peer" @change="toggleDarkMode" ref="darkModeCheckbox" />
          <div
            class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-greenrefah">
          </div>
        </label>
      </div>
    </nav>
  </div>
  <div class="mt-[70px] mb-10 text-gray-800 dark:text-white">
    <router-view v-slot="{ Component, route }">
      <transition name="fade">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>
  </div>

  <footer class="bg-white rounded-lg shadow dark:bg-black border-t border-gray-200 dark:border-gray-700">
    <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
      <div class="sm:flex sm:items-center sm:justify-between">
        <a href="https://binesheno.com/" class="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse">
          <img src="@/assets/images/logo.png" class="h-8" alt="Flowbite Logo" />
          <span
            class="self-center text-sm whitespace-nowrap text-white bg-primary p-2 rounded-tr-lg rounded-bl-lg">پایگاه
            اطلاع رسانی آیت الله مرتضی رضوی</span>
        </a>
        <ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
          <li>
            <router-link to="/fa/aboutus" class="hover:underline me-4 md:me-6">درباره ما</router-link>
          </li>
          <!-- <li>
                        <router-link to="/fa/contactus" class="hover:underline me-4 md:me-6">تماس با ما</router-link>
                    </li> -->
        </ul>
      </div>
      <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
      <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© 1404 <router-link to="/fa"
          class="hover:underline">بینش نو</router-link>. تمامی حقوق مادی و معنوی وبسایت، محفوظ است</span>
    </div>
  </footer>
  <button v-if="isVisible" @click="scrollToTop"
    class="text-sm fixed bottom-4 right-4 bg-primary text-white px-3 py-1 rounded-tr-lg rounded-bl-lg shadow-md transition transform hover:scale-110 dark:bg-primary"
    aria-label="Scroll to top">برگشت به بالا</button>

  <nav
    class="flex xl:hidden gap-4 fixed bg-white dark:bg-black border-t bottom-0 right-0 left-0 justify-around p-4 border-gray-200 dark:border-gray-700">
    <router-link to="/fa"
      class="flex items-center justify-center hover:text-primary dark:hover:text-primary xl:justify-start refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa', 'text-gray-800 dark:text-white': $route.path !== '/fa' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
        <path
          d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
          fill="currentColor" />
      </svg>
    </router-link>
    <router-link to="/fa/library"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/library', 'text-gray-800 dark:text-white': $route.path !== '/fa/library' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
        <path
          d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
          fill="currentColor" />
      </svg>
    </router-link>
    <router-link to="/fa/posts"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/posts', 'text-gray-800 dark:text-white': $route.path !== '/fa/posts' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
        <path
          d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
          fill="currentcolor" />
      </svg>
    </router-link>
    <router-link to="/fa/media"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/media', 'text-gray-800 dark:text-white': $route.path !== '/fa/media' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
        <path
          d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
          fill="currentColor" />
      </svg>
    </router-link>
    <router-link to="/fa/aboutus"
      class="flex items-center justify-center xl:justify-start hover:text-primary dark:hover:text-primary refahemelli_blur relative"
      :class="{ 'text-primary': $route.path === '/fa/aboutus', 'text-gray-800 dark:text-white': $route.path !== '/fa/aboutus' }">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
        <path
          d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
          fill="currentcolor" />
      </svg>
    </router-link>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import TheAside from "@/containers/TheAside.vue";
import TheSeccoundAside from "./TheSeccoundAside.vue";
import LoadingBar from "@/components/LoadingBar.vue";
export default {
  name: "TheContainer",
  components: {
    TheAside,
    TheSeccoundAside,
    LoadingBar,
  },
  data() {
    return {
      isVisible: false,
      languageId: null,
    };
  },
  computed: {
    ...mapGetters({
      language: "baseX/language",
    }),
    pageTitle() {
      return this.$route.meta.title;
    },
    isInternalPage() {
      return this.$route.name !== "Home";
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    $route() {
      this.$refs.loadingBar.startLoading();
      setTimeout(() => {
        this.$refs.loadingBar.stopLoading();
      }, 1000);
    },
    language() {
      if (this.language && this.language.length > 0) {
        const find = this.language.find((z) => z.codeKey === this.$route.path.substring(1));
        if (find) {
          this.languageId = find.id;
          localStorage.setItem("languageId", find.id);
          this.reloadData();
        }
      }
    },
  },
  metaInfo: {
    titleTemplate: process.env.VUE_APP_BASE_TITLE,
    meta: [{ charset: "utf-8" }],
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.isVisible = window.scrollY > 300;
    },
    toggleDarkMode(event) {
      if (event.target.checked) {
        document.querySelector("html").classList.add("dark");
        localStorage.setItem("darkMode", "enabled");
      } else {
        document.querySelector("html").classList.remove("dark");
        localStorage.setItem("darkMode", "disabled");
      }
    },
    setLanguage(data) {
      this.languageId = data.id;
      this.reloadData();
      localStorage.setItem("languageId", data.id);
      this.$router.push({
        name: "Home",
        params: { lang: data.codeKey },
      });
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      el.offsetHeight;
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 1;
      done();
    },
    leave(el, done) {
      el.style.transition = "opacity 0.5s";
      el.style.opacity = 0;
      done();
    },

    reloadData() { },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$store.dispatch("baseX/getLanguage");
    const darkMode = localStorage.getItem("darkMode");
    if (darkMode === "enabled") {
      document.querySelector("html").classList.add("dark");
      this.$refs.darkModeCheckbox.checked = true;
    }
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
@media print {
  .noprint {
    display: none !important;
  }
}
</style>
